import { useEffect } from 'react';
import userFields from '../../fields/userFields';
import buildDictionary from '@/common-utils/functions/buildDictionary';
import USER_PROFILES from '../../enums/UserProfiles';
import MERCHANT_USER_PROFILES from '@/app/modules/users/merchant/enums/MerchantUserProfiles';


const useUserPermissions = (getProfilesResponse, getUserResponse, userPermissions, userProfile, profiles, setters) => {
    const {
        setAllPermissionsToDisplay,
        setProfiles,
        setProfilesNames,
        setUserPermissions,
        setDefaultUserPermissions,
        setUserProfile,
        setDefaultUserProfile,
        setDisableResetToDefaultPermissions
    } = setters;
    useEffect(() => {
        if (!getProfilesResponse.isLoading && !getProfilesResponse.isError && getProfilesResponse.data) {
            const profilesObject = {};
            Object.entries(getProfilesResponse.data).forEach((value) => {
                const name = value[1].name;
                profilesObject[name] = {
                    uuid: value[0],
                    name: name,
                    permissions: value[1].permissions
                };
                if (name === USER_PROFILES.PROFILE_ADMIN.name || name === MERCHANT_USER_PROFILES.PROFILE_ADMIN_MERCHANT.name) {
                    setAllPermissionsToDisplay(value[1].permissions);
                }
            });
            setProfiles(profilesObject);
            setProfilesNames(buildDictionary(Object.values(getProfilesResponse.data), 'name'));
        }
    }, [getProfilesResponse.isLoading, getProfilesResponse.isError, getProfilesResponse.data]);
    useEffect(() => {
        if (!getUserResponse.isLoading && !getUserResponse.isError && getUserResponse.data) {
            setUserPermissions(getUserResponse.data[userFields.PERMISSIONS.key]);
            setDefaultUserPermissions(getUserResponse.data[userFields.PERMISSIONS.key]);
            setUserProfile(getUserResponse.data[userFields.PROFILE.key]);
            setDefaultUserProfile(getUserResponse.data[userFields.PROFILE.key]);
        }
    }, [getUserResponse.isLoading, getUserResponse.isError, getUserResponse.data]);
    useEffect(() => {
        if (userPermissions && profiles && userProfile) {
            if (userPermissions.length === profiles[userProfile].permissions.length &&
                userPermissions.every(perm => profiles[userProfile].permissions.includes(perm))) {
                setDisableResetToDefaultPermissions(true);
            } else {
                setDisableResetToDefaultPermissions(false);
            }
        } else {
            setDisableResetToDefaultPermissions(true);
        }
    }, [userPermissions]);
};

export default useUserPermissions;